import { render, staticRenderFns } from "./LoadAuthorizationsResults.vue?vue&type=template&id=15209062&scoped=true"
import script from "./LoadAuthorizationsResults.vue?vue&type=script&lang=js"
export * from "./LoadAuthorizationsResults.vue?vue&type=script&lang=js"
import style0 from "./LoadAuthorizationsResults.vue?vue&type=style&index=0&id=15209062&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15209062",
  null
  
)

export default component.exports